import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import styles from './styles';
// import data from './currentWeatherData.json';
import currentWeatherSample from './currentWeatherData.js';
import icons from '../../assets/images';

class CurrentWeather extends React.PureComponent {
  render() {
    const {
      classes: {
        container,
        leftPanel,
        rightPanel,
        centerPanel,
        panelTitleText,
        weatherIcon,
        weatherText,
      }, t,
    } = this.props;
    const weatherData = window.location.href;
     
    const CurrentWeatherForecast = unescape(currentWeatherSample);
    const wc = JSON.parse(CurrentWeatherForecast);
    const weatherImage = `weather${wc.WeatherIcon}`;
    return (
      <React.Fragment>
        <div className={container}>
          <div className={leftPanel}>
            <div>
              <div className={panelTitleText}>{t('screens.weather.current.currently')}</div>
              <div className={weatherIcon}>
              <img alt="weather" src={icons[weatherImage]} />
              </div>
              <div className={weatherText}>{wc.WeatherText}</div>
            </div>
          </div>
          <div className={centerPanel}>{this.renderCenterPanel()}</div>
          <div className={rightPanel}>{this.renderRightPanel()}</div>
        </div>
      </React.Fragment>
    );
  }

  /**
   * @name renderCenterPanel
   * @description render the DOM for the Center Panel
   */
  renderCenterPanel = () => {
    const {
      classes: { panelTitleText, panelSection, temperature, weatherText, additionalInfo }, t,
    } = this.props;

    const CurrentWeatherForecast = unescape(currentWeatherSample);
    const wc = JSON.parse(CurrentWeatherForecast);
    return (
      <React.Fragment>
        <div className={panelSection}>
          <div className={panelTitleText}>{wc.Time}</div>
          <div className={temperature}>{wc.Temperature.Value}&#176;</div>
          <div className={weatherText}>{t('screens.weather.feelslike')} {wc.FeelsLike.Value}&#176;</div>
        </div>
        <div className={panelSection}>
          <div
            className={additionalInfo}
          >{`${wc.PrecipitationProbability}% ${t('screens.weather.current.chancePrecip')}`}</div>
          <div className={additionalInfo}>{wc.WindDescriptionInformation}</div>
        </div>
      </React.Fragment>
    );
  };

  /**
   * @name renderRightPanel
   * @description render the DOM for the Right Panel
   */
  renderRightPanel = () => {
    const {
      classes: { panelTitleText, panelSection }, t,
    } = this.props;
    const CurrentWeatherForecast = unescape(currentWeatherSample);
    const wc = JSON.parse(CurrentWeatherForecast);
    return (
      <React.Fragment>
        <div className={panelSection}>{this.renderHighLowInfo()}</div>
        <div className={panelSection}>
          <div className={panelTitleText}>{`${t('screens.weather.current.cloudCover')} - ${wc.CloudCover}%`}</div>
          <div className={panelTitleText}>{`${t('screens.weather.current.uvIndex')} (11)`}</div>
        </div>
      </React.Fragment>
    );
  };

  /**
   * @renderHighLowInfo
   * @description renders DOM for High-Low temp section
   */
  renderHighLowInfo = () => {
    const {
      classes: {
        panelTitleText,
        weatherText,
        highLowTempSection,
        highTemp,
        tempDivider,
        lowTemp,
        lowTempWrapper,
        lowTempTitle,
        dividerBox,
        dividerLine,
      }, t
    } = this.props;
    const CurrentWeatherForecast = unescape(currentWeatherSample);
    const wc = JSON.parse(CurrentWeatherForecast);
    return (
      <React.Fragment>
        <div className={highLowTempSection}>
          <div className={highTemp}>
            <div className={panelTitleText}>{t('screens.weather.high')}</div>
            <div className={weatherText}>{wc.TemperatureHigh.Value}&#176;</div>
          </div>
          <div className={tempDivider}>
            <div className={dividerBox}>
              <div className={dividerLine}></div>
            </div>
          </div>
          <div className={lowTempWrapper}>
            <div className={lowTempTitle}>
              <span className={panelTitleText}>{t('screens.weather.low')}</span>
            </div>
            <div className={lowTemp}>
              <span className={panelTitleText}>{wc.TemperatureLow.Value}&#176;</span>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };
}

CurrentWeather.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

export default withStyles(styles)(withTranslation()(CurrentWeather));
